'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _isNaN = require('lodash/isNaN');

var _isNaN2 = _interopRequireDefault(_isNaN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _isNaN2.default;


//////////////////
// WEBPACK FOOTER
// ./~/coact-utils/isNotANumber.js
// module id = 1258
// module chunks = 0